import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import './App.css';
import Dashboard from './components/dashboard/dashboard';
import Forget from './components/forgetPage/forget';
import Loading from './components/loadingPage/loading';
import Login from './components/loginPage/login';
import ResetPassword from './components/resetPasswordPage/resetPassword';
import Signup from './components/signupPage/signup';
import Todolist from './components/todoList/todolist';
import Header from "./components/header/header";
import AddtaskTodo from "./components/todoList/addtask";
import EdittaskTodo from "./components/todoList/edittask";
import { Clock } from "./components/clock/clock";
import Prescription from "./components/prescription/prescription";
import Addtask from "./components/prescription/addtask";
import Edittask from "./components/prescription/edittask";
import Scheduler from "./components/schedulerPage/scheduler";
import { Path } from "./RoutesUtils";


function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path={Path.home} element={<Dashboard />} />
          <Route path={Path.scheduler} element={<Scheduler />} />
          <Route path={Path.toDoList} element={<Todolist />} />
          <Route path={Path.addTask} element={<AddtaskTodo />} />
          <Route path={Path.editTask} element={<EdittaskTodo />} />
          <Route path={Path.clock} element={<Clock />} />
          <Route path={Path.prescription} element={<Prescription />} />
          <Route path={Path.addPrescription} element={<Addtask />} />
          <Route path={Path.editPrescription} element={<Edittask />} />
          <Route path={Path.forgotPassword} element={<Forget />} />
          <Route path={Path.resetPassword} element={<ResetPassword />} />
          <Route path={Path.login} element={<Login />} />
          <Route path={Path.signUp} element={<Signup />} />
          <Route path="*" element={<Navigate to={Path.login} replace />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
